export default function GradientBlue({type, value, onClick=""}) {
  return (
    <input
      className="w-full bg-zi-gradient-button-blue text-zi-gray-light text-base py-2 rounded-lg cursor-pointer outline-none hocus:ring-offset-1 hocus:ring-1 hocus:ring-zi-blue-light"
      type={type}
      value={value}
      onClick={onClick}
    >
    </input>
  )
}